import { createContext, useContext, useMemo } from 'react';
import type { OrderSummary } from '../../types/OrderHistory.types';
import type { OrderSummaryContextType } from '../../types/OrderSummaryContext.types';

const OrderSummaryContext = createContext<OrderSummaryContextType | undefined>(
  undefined
);

export const OrderSummaryProvider = ({
  children,
  order,
  displayPosition,
}: {
  children: React.ReactNode;
  order: OrderSummary;
  displayPosition: number;
}) => {
  const orderSummaryContextValue = useMemo(
    () => ({
      order,
      displayPosition,
    }),
    [order, displayPosition]
  );

  return (
    <OrderSummaryContext.Provider value={orderSummaryContextValue}>
      {children}
    </OrderSummaryContext.Provider>
  );
};

export const useOrderSummary = (): OrderSummaryContextType => {
  const context = useContext(OrderSummaryContext);
  if (!context) {
    throw new Error(
      'useOrderSummary must be used within an OrderSummaryProvider'
    );
  }
  return context;
};
